import React, { useEffect, useState } from 'react'
import { css } from 'styled-components'
import { createPortal } from 'react-dom'
import { ReactComponent as SettingsIcon } from 'assets/img/settings.svg'
import { PRIMARY_TEXT, WHITE, BORDER_BLACK } from 'constants/colors'
import { BUTTON_TYPE_SECONDARY } from 'components/common/Button/constants'
import Loader from 'components/Loading/SmallLoader'
import { ReactComponent as PlusIcon } from 'assets/img/plus-icon.svg'
import StyledButton from 'components/common/Button/Button'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { Site } from 'types/common'
import { LAPTOP_BREAKPOINT } from 'helpers/responsive'
import { ButtonLabel } from './MobileFilterButton.styles'
import { MobileFilterButtonProps } from './MobileFilterButton.types'

export const MobileFilterButton = ({
  siteList,
  site,
  setMobileFilter,
  createWorkflow,
}: MobileFilterButtonProps) => {
  const isMobileResolution = ifWindowWidthLessThan(LAPTOP_BREAKPOINT)

  const [mount, setMount] = useState<ShadowRoot>()

  useEffect(() => {
    const createJobEl = document.createElement('div')
    const attachElApps = document.body.querySelector('.module-head')
    createJobEl.style.width = '24px'
    createJobEl.style.height = '24px'

    if (isMobileResolution && attachElApps) {
      attachElApps?.firstElementChild?.append(createJobEl)

      setMount(createJobEl.attachShadow({ mode: 'open' }))
    }

    return () => {
      if (attachElApps && isMobileResolution) {
        attachElApps?.firstElementChild?.removeChild(createJobEl)
      }
    }
  }, [isMobileResolution, document.body.querySelector('.module-head')])

  return (
    <>
      {mount &&
        createPortal(
          <PlusIcon height="24px" width="24px" onClick={createWorkflow} />,
          mount,
        )}
      <StyledButton
        customStyles={css`
          bottom: 15px;
          left: 50%;
          position: fixed;
          z-index: 1;
          background-color: ${WHITE};
          border: 1.5px solid ${BORDER_BLACK};
          border-radius: 12px;
          font-size: 16px;
          font-weight: 500;
          color: ${PRIMARY_TEXT};
          padding: 8px 11px;
          transform: translate(-50%, 0);
          line-height: 26px;
          max-width: 200px;
        `}
        type={BUTTON_TYPE_SECONDARY}
        startIcon={<SettingsIcon />}
        onClick={() => setMobileFilter(true)}>
        {siteList && siteList.size ? (
          <ButtonLabel>
            {
              (
                siteList.find((siteItem?: Site) => siteItem?.id === site) ||
                siteList.get(0)
              ).name
            }
          </ButtonLabel>
        ) : (
          <Loader />
        )}
      </StyledButton>
    </>
  )
}
